<div class="container-fluid page">
  <div class="page-content shadow position-relative">
    <mat-tab-group>
      <mat-tab label="Adapters List">
        <ng-template matTabContent>
          <div class="px-4 py-2">
            <form class="row mat-form" [formGroup]="filterForm">
              <div class="col-md-12">
                <app-input-select
                  (selectionChange)="listAdapters()"
                  [inputData]="attrConstant.partner"
                  [selectOptions]="partnerList$ | async"
                  [bindLabel]="'name'"
                  [bindValue]="'partner_id'"
                  [formControlName]="
                    attrConstant.partner.key
                  "></app-input-select>
              </div>
            </form>
            <table mat-table [dataSource]="dataSource" matSort>
              <!-- Adapter Column -->
              <ng-container matColumnDef="adapter_name">
                <th mat-header-cell *matHeaderCellDef>Adapter</th>
                <td mat-cell *matCellDef="let element" data-label="Adapter">
                  {{ element.adapter_name }}
                </td>
              </ng-container>

              <!-- Adapter Type Column -->
              <ng-container matColumnDef="adapter_type">
                <th mat-header-cell *matHeaderCellDef>Adapter Type</th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  data-label="Adapter Type">
                  {{ element.adapter_type }}
                </td>
              </ng-container>

              <!-- Created At Column -->
              <ng-container matColumnDef="created_at">
                <th mat-header-cell *matHeaderCellDef>Created At</th>
                <td mat-cell *matCellDef="let element" data-label="Created At">
                  {{ element.created_at | date: 'dd/MM/yyyy' }}
                </td>
              </ng-container>

              <!-- Action Column -->
              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef>Action</th>
                <td mat-cell *matCellDef="let element" data-label="Action">
                  <div class="d-flex align-items-center action-gap-10">
                    <img
                      src="assets/images/edit-icon.svg"
                      alt="edit-icon"
                      matTooltip="Edit"
                      matTooltipPosition="left"
                      [attr.aria-hidden]="true"
                      (click)="updateAdapterSetting(element)"
                      *appHasAccess="'edit-master-partner-adapter-setting'" />
                    <img
                      src="assets/images/delete-icon.svg"
                      alt="delete-icon"
                      matTooltip="Delete"
                      matTooltipPosition="right"
                      [attr.aria-hidden]="true"
                      (click)="deleteAdapterSetting(element)"
                      *appHasAccess="'delete-master-partner-adapter-setting'" />
                  </div>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr
                mat-row
                class="custom-mat-btn"
                *matRowDef="
                  let row;
                  columns: displayedColumns;
                  let element
                "></tr>
            </table>
          </div>
        </ng-template>
      </mat-tab>
      <mat-tab disabled *appHasAccess="'add-master-partner-adapter-setting'">
        <ng-template mat-tab-label>
          <button class="btn primary-btn" (click)="addAdapterSetting()">
            Add Adapter Setting
          </button>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
